export default __webpack_public_path__ + "static/media/ctg-5b.abdcd516.webp";